// src/pages/impersonate/impersonate.tsx

import React, { FC, useState } from 'react'
import { processErrorMsg, storage, processUserNameChange } from 'utils'
import {
  BaseLayout,
  ButtonContainer,
  CustomAlert,
  Loader,
  Module,
  ModuleHeader,
  ModuleBody,
  AutoCompleteContainer,
} from 'components/'
import {
  AutocompleteChangeReason,
  AutocompleteChangeDetails,
} from '@mui/material'
import Button from '@mui/material/Button'
import useStyles from './impersonate-style'

const Impersonate: FC = () => {
  const [impersonateUserNameSearch, setImpersonateUserNameSearch] = useState('')
  const [impersonateUser, setImpersonateUser] = useState<any | null>(null)
  const [autoCompleteOpen, setAutoCompleteOpen] = useState(false)
  const [filteredUserList, setFilteredUserList] = useState<Array<string>>([])
  const [lastUserSearch, setLastUserSearch] = useState('')
  const [lastUserSearchResults, setLastUserSearchResults] = useState([])
  const [errorAlertMessage, setErrorAlertMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [hideLoader, setHideLoader] = useState(true)

  const USER_SEARCH_LIMIT = 200

  const { classes } = useStyles()

  const onChangeSelection = (
    event: React.ChangeEvent<{}>,
    value: any | null,
    reason: AutocompleteChangeReason,
    details?: AutocompleteChangeDetails<string> | undefined,
  ) => {
    let newValue = {}
    if (value != null) {
      newValue = value
    }
    setImpersonateUser(newValue)
  }

  const userNameChange = (
    event: React.ChangeEvent<{}>,
    value: string,
    reason: string,
  ) => {
    const accessToken =
      'Bearer ' +
      JSON.parse(localStorage.getItem('okta-token-storage') ?? '')?.accessToken
        ?.accessToken

    processUserNameChange(
      reason,
      value,
      lastUserSearch,
      lastUserSearchResults,
      USER_SEARCH_LIMIT,
      accessToken,
      setImpersonateUserNameSearch,
      setFilteredUserList,
      setAutoCompleteOpen,
      setLastUserSearch,
      setLoading,
      setLastUserSearchResults,
      setErrorAlertMessage,
      processErrorMsg,
    )
  }

  const updateImpersonateUser = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    if (impersonateUser != null) {
      setHideLoader(false)

      const accessToken =
        'Bearer ' +
        JSON.parse(localStorage.getItem('okta-token-storage') ?? '')
          ?.accessToken?.accessToken

      storage.setUser(impersonateUser.login)

      console.log(accessToken)

      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: accessToken,
        },
      }
      const url =
        process.env.REACT_APP_UPDATE_APPUSER_ENDPOINT +
        '?impersonate=' +
        impersonateUser.memberMlsId

      fetch(url, requestOptions)
        .then(async (response) => {
          const data = await response.json()

          // check for error response
          if (!response.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || response.status
            return Promise.reject(error)
          }

          // If we have successfully updated our impersonateUsername attribute, then redirect to the Gateway page
          //console.log("Success!", data);
          document.location.href =
            process.env.REACT_APP_IMPERSONATE_GATEWAY_URL!
        })
        .catch((error) => {
          processErrorMsg(
            error,
            'Impersonate',
            `Update impersonate user. Unable to process api ${url}`,
          )
          setHideLoader(true)
        })
    }
  }

  return (
    <BaseLayout>
      <Loader visible={!hideLoader} />
      <Module>
        <ModuleHeader title="Impersonate">
          <CustomAlert severity="error">{errorAlertMessage}</CustomAlert>
        </ModuleHeader>

        <ModuleBody>
          <AutoCompleteContainer
            className={classes.autoCompleteTextInput}
            autoCompleteOpen={autoCompleteOpen}
            hideLoader={hideLoader}
            userNameChange={userNameChange}
            onChangeSelection={onChangeSelection}
            setAutoCompleteOpen={setAutoCompleteOpen}
            filteredUserList={filteredUserList}
            searchText={impersonateUserNameSearch}
            isLoading={loading}
            labelText="Find Account:"
          />
          <ButtonContainer
            primary={
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={updateImpersonateUser}
                disabled={impersonateUser == null || !hideLoader}
              >
                Go
              </Button>
            }
          />
        </ModuleBody>
      </Module>
    </BaseLayout>
  )
}

export default Impersonate
